export default __webpack_public_path__ + "static/acknowledgment-logos-6e6a5ab2bfc95d0fae85bc375ce54486.jpg";